export default __webpack_public_path__ + "static/media/crown.ed86f8d8.png";